module.exports = __webpack_public_path__ + "static/media/paintCanQuestion.5d0b96d3.png";